const name = 'BaseNone';
const properties = {};
function animate(kit, elements, duration = 0, delay = 0, params = {}) {
    const to = {};
    return kit.engine.tween(elements, { duration, delay, ...params, to }, []);
}
export { name, properties, animate };
//# sourceMappingURL=baseNone.js.map